import {IDLE} from "../../common/statuses";

export const initialState = {
    getInfo: {
        data: undefined,
        status: IDLE,
    },
    getNotifications: {
        data: undefined,
        status: IDLE,
    },
    personalSettings: {
        data: undefined,
        status: IDLE,
    },
}